import { useEffect, useState } from "react";
import { IoPencil } from "react-icons/io5";
import {useHistory, useParams} from "react-router";
import {Link} from "react-router-dom";

export const Items = ({ items, isModifier }) => {
    const [state, setState] = useState([]);
    const { slug } = useParams();
    useEffect(() => setState(items), [items]);

    if (!items) return null;

    return (
        <div>
            {state.map(({id, category_id, name, title, photo_thumb, photo}) => (
                <div
                    key={id}
                    className="bg-gray-50 flex items-center justify-between sm:rounded-lg my-1 mx-auto px-2 w-full h-12"
                >
                    <div className="flex items-center p-2">
                        {!isModifier &&
                            <Link to={`/chain/menu/${slug}/dishes/${id}/edit`}>
                                <img
                                    className="rounded-full"
                                    src={photo_thumb ?? photo}
                                    width={42}
                                    height={42}
                                    alt=""
                                />
                            </Link> }

                        <span className="text-xs font-normal text-purple-500 px-11">
                            { isModifier
                                ? <Link to={`/chain/menu/${slug}/modifiers/${category_id}/edit`}>{title || name || ""}</Link>
                                : <Link to={`/chain/menu/${slug}/dishes/${id}/edit`}>{title || name || ""}</Link> }
                        </span>
                    </div>

                    <div className="flex items-center pr-3.5">
                        { isModifier
                                ? <Link to={`/chain/menu/${slug}/modifiers/${category_id}/edit`}>
                                    <IoPencil className="text-indigo-600 cursor-pointer" /></Link>
                                : <Link to={`/chain/menu/${slug}/dishes/${id}/edit`}>
                                    <IoPencil className="text-indigo-600 cursor-pointer" /></Link> }
                    </div>
                </div>
            ))}
        </div>
    );
};
